import { ArrowLeft } from 'lucide-react';

interface PrivacyScreenProps {
  onBack: () => void;
}

export const PrivacyScreen = ({ onBack }: PrivacyScreenProps) => {
  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Header */}
      <div className="bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
        <div className="flex items-center gap-3 p-4">
          <button
            onClick={onBack}
            className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-[#111827]" />
          </button>
          <h1 className="text-lg font-bold text-[#111827]">Aviso de privacidad</h1>
        </div>
      </div>

      {/* Content */}
      <div className="p-4 pb-8">
        <div className="bg-white rounded-[16px] border border-[#E5E7EB] p-6 space-y-6">
          <div>
            <p className="text-xs text-[#6B7280] mb-4">
              Última actualización: 15 de enero de 2026
            </p>
            <p className="text-sm text-[#6B7280] leading-relaxed">
              En Mexmo, nos comprometemos a proteger tu privacidad y datos personales. Este aviso describe cómo recopilamos, usamos y protegemos tu información.
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <h3 className="font-bold text-[#111827] mb-2">1. Información que recopilamos</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Recopilamos información que nos proporcionas directamente, como nombre, correo electrónico, número de teléfono y detalles de pago. También recopilamos información sobre tu uso de la plataforma, como búsquedas realizadas y boletos comprados.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">2. Uso de la información</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Utilizamos tu información para: procesar tus compras, enviarte confirmaciones y actualizaciones de viaje, mejorar nuestros servicios, prevenir fraudes y cumplir con requisitos legales.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">3. Compartir información</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Compartimos tu información con las líneas de autobús para procesar tu reserva, con procesadores de pago para completar transacciones, y con autoridades cuando sea legalmente requerido. No vendemos tu información personal a terceros.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">4. Seguridad de datos</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Implementamos medidas de seguridad técnicas y organizativas para proteger tu información contra acceso no autorizado, pérdida o alteración. Utilizamos encriptación SSL/TLS para todas las transacciones.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">5. Tus derechos</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Tienes derecho a acceder, rectificar, cancelar u oponerte al tratamiento de tus datos personales. Para ejercer estos derechos, contáctanos en privacidad@mexmo.com
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">6. Cookies</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Utilizamos cookies y tecnologías similares para mejorar tu experiencia, recordar tus preferencias y analizar el uso de nuestra plataforma. Puedes configurar tu navegador para rechazar cookies.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">7. Retención de datos</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Conservamos tu información personal durante el tiempo necesario para cumplir con los fines descritos en este aviso, a menos que la ley requiera un período de retención más largo.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">8. Cambios a este aviso</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Podemos actualizar este aviso periódicamente. Te notificaremos sobre cambios significativos a través de correo electrónico o un aviso en la plataforma.
              </p>
            </div>

            <div>
              <h3 className="font-bold text-[#111827] mb-2">9. Contacto</h3>
              <p className="text-sm text-[#6B7280] leading-relaxed">
                Si tienes preguntas sobre este aviso de privacidad, contáctanos en privacidad@mexmo.com o llámanos al +52 55 1234 5678.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
